module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sale1-deda2a59064159f49bcd610e7951d882.svg";